import React, { memo, useCallback, useState } from 'react';
import { createUseStyles, Input, Button, Advice } from '@Sage/hoi-poi-ui';

import useLoginLiterals from 'lib/useLoginLiterals';

import { FadeTransition } from 'components/Transitions';

import AuthBox from '../components/AuthBox';

import styles from './styles.js';
const useStyles = createUseStyles(styles, 'RecoverPassword');

const RecoverPassword = ({ logo, onSend, iframeURL }) => {
    const classes = useStyles();

    const [username, setUsername] = useState();
    const [formState, setFormState] = useState({
        error: null,
        success: null,
        loading: false,
    });

    const { loading, t } = useLoginLiterals();

    const send = useCallback(
        (e) => {
            e?.preventDefault?.();

            if (!username) return;

            setFormState({
                error: null,
                success: null,
                loading: true,
            });

            onSend(username)
                .then((successLiteral) => {
                    setFormState({
                        success: successLiteral
                            ? t(successLiteral)
                            : t('succes_new_password_email_sent'),
                        error: false,
                        loading: false,
                    });
                    setUsername('');
                })
                .catch((e) => {
                    console.error(e);
                    setFormState({
                        success: false,
                        error: t('error_generalerror'),
                        loading: false,
                    });
                });
        },
        [onSend, t, username],
    );

    if (loading) return null;

    return (
        <AuthBox
            title={t('label_change_password')}
            logo={logo}
            iframeURL={iframeURL ? t(iframeURL) : null}
        >
            <FadeTransition transitionKey="error" show={formState.error}>
                <Advice
                    className={classes.advice}
                    type="error"
                    showIcon
                    defaultCollapsed={false}
                    showCollapse={false}
                >
                    {formState.error}
                </Advice>
            </FadeTransition>
            <FadeTransition transitionKey="sucess" show={formState.success}>
                <Advice
                    className={classes.advice}
                    type="success"
                    showIcon
                    defaultCollapsed={false}
                    showCollapse={false}
                >
                    {formState.success}
                </Advice>
            </FadeTransition>
            <form onSubmit={send}>
                <Input
                    label={t('label_email_or_mobile_login')}
                    placeholder={t('label_email_or_mobile_login')}
                    type="text"
                    onChange={setUsername}
                    value={username}
                    isFullWidth
                    isDisabled={formState.loading}
                    autoFocus
                />
                <div className={classes.footer}>
                    <Button onClick={send} isLoading={formState.loading}>
                        {t('action_next')}
                    </Button>
                </div>
            </form>
        </AuthBox>
    );
};

export default memo(RecoverPassword);
